import { computed } from 'vue'

const formatTime = startTime => {
  const date = new Date(startTime)
  return date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false // Specify 24-hour time format
  })
}

export function useAdjustedStatus(event, loc, langId) {
  return computed(() => {
    const { status } = event.value

    let statusLocalized = status?.event === 'live' ? status.event : status?.match || "NA"

    const supportedStatuses = ['ended', 'walkover', 'retired', 'cancelled', 'live']
    statusLocalized = supportedStatuses.includes(statusLocalized)
      ? loc(`sm_tennis_status_${statusLocalized}`, langId)
      : statusLocalized

    const spriteIdMap = {
      'ended': 'ended',
      'closed': 'ended',
      'cancelled': 'cancelled',
      'walkover': 'cancelled',
      'retired': 'cancelled',
      'live': 'live-indicator',
      'not_started': 'clock'
    }

    const time = formatTime(event.value.startTime)
    const isUpcoming = status?.event === 'not_started'

    return {
      spriteId: spriteIdMap[status?.event] || 'cancelled',
      color: status?.event === 'live' ? '#FF5F54' : '#8B919E',
      statusLabel: isUpcoming ? time : statusLocalized
    }
  })
}
